<template>
    <div class="wrapper--section section-dropdowns" :style="`--bg: ${background}`">
        <div class="section-container section-dropdowns__row" data-flex="row" data-flex--justify="between">

            <div class="section__header section-text__content text--left has-overflow">
                <h2 class="title title--dash" v-html="title" />
                <div class="section__text" v-if="text">
                    <p v-html="text" />
                </div>
            </div>
    
            <div class="dropdowns">
                <div class="dropdown" v-for="(item, i) in items" :key="i">
                    <h3>
                        <span class="more more--slide">
                            <span class="more__icon"><i /></span>
                        </span>
                        <button
                            type="button"
                            :aria-expanded="activeTab === i"
                            :aria-controls="`dd-panel-${i}`"
                            class="dropdown__title"
                            v-text="item.title"
                            :id="`dd-btn-panel-${i}`"
                            @click="setActive(i)"
                        />
                    </h3>
                    <div
                        :id="`dd-panel-${i}`" 
                        role="region" :aria-labelledby="`dd-btn-panel-${i}`"
                        :hidden="activeTab !== i"
                        class="dropdown__content"
                    >
                        <div v-html="item.text.includes('<ol>') || item.text.includes('<ul>') ? item.text : `<p>${item.text}</p>`" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { textProps, optionsProps } from './sectionProps'

export default {
    props: {
        items: {
            type: [Array, Boolean],
        },
        ...textProps,
        ...optionsProps,
    },

    data: () => ({
        activeTab: -1,
    }),

    methods: {
        setActive( i ) {
            this.activeTab = this.activeTab === i ? -1 : i
        },
    },
}
</script>

<style lang="scss" scoped>
.section-dropdowns__row {
    align-items: flex-start;
    gap: 2rem;
}

.dropdowns {
    width: 100%;
}

.dropdown {
    width: 100%;
    position: relative;
    margin-bottom: 2px;
    font-size: 1.125rem;
    border-radius: 1em;

    --dd-offset: 80px;

    h3 {
        display: flex;
        align-items: center;
    }

    ::v-deep ol {
        list-style: decimal;
        padding-left: 1em;

        ::marker {
            color: var(--coral-dark);
        }

        li {
            font-size: 1rem;
            margin-top: .125em;
            padding-left: .25em;
            @media (width > 1366px) {
                font-size: 1.125rem;
            }
        }
    }

    .more {
        --more-size: 32px;
        --more-size-x: 14px;
        --more-fs: 80%;
        --btn-color: var(--purple);
        margin-left: 1.25em;
        pointer-events: none;
    }

    &:has(button:hover) {
        .more__icon {
            transform: rotate(90deg);
        }
    }
    &:has([aria-expanded=true]) {
        .more {
            --btn-color: var(--coral-dark);
        }
        .more__icon {
            transform: rotate(135deg) !important;
        }
    }

    &::after {
        content: '';
        display: block;
        height: 1em;
        margin-top: calc(-1em + 1px);
        border-radius: 0 0 1em 1em;
        box-shadow: inset 0 -1px 0 0 var(--purple);
    }
}

.dropdown button {
    width: 100%;
    display: block;
    text-align: left;
    appearance: none;
    color: var(--purple);
    background-color: #fff0;
    padding: 1em 1.5em;
    padding-left: var(--dd-offset);
    font-size: inherit;
    border-radius: 1em;
    border: none;

    &:focus {
        outline: none;
    }
    &:focus-visible {
        outline: 2px solid var(--purple);
        outline-offset: -10px;
    }
}

:root {
    interpolate-size: allow-keywords;
}

.dropdown__content {
    padding: 0 1.5em 2rem;
    padding-left: var(--dd-offset);

    transition: all 0.5s var(--timing);
    transition-property: display, translate, opacity;
    transition-behavior: allow-discrete;
    opacity: 1;

    &[hidden] {
        opacity: 0;
        transition-duration: 0.00000001ms;
    }

    &:not([hidden]) {
        @starting-style {
            translate: 0 -.75em;
            opacity: 0;
        }
    }
}

@media (width > 767px) {
    
    .section-dropdowns__row {
        gap: 2%;
        flex-wrap: nowrap;
    }
    .section__header {
        flex-basis: 50%;
        margin-top: .5rem;
    }
    .dropdown {
        font-size: 1.25rem;
        transition: background-color .2s;
    }
    .dropdown:hover:not(:has([aria-expanded=true])) {
        background-color: color-mix(in srgb, var(--purple) 10%, #fff0);
    }
}
@media (width > 1280px) {

    .dropdown {
        --dd-offset: 250px;
        font-size: 1.5rem;
    }
    .dropdown .more {
        --more-size: 44px;
        --more-size-x: 16px;
        --more-fs: 80%;
    }
}
</style>